"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _NavigationBar = _interopRequireDefault(require("@kiwicom/orbit-components/lib/NavigationBar"));
var events = _interopRequireWildcard(require("../TopNav/consts/events"));
var _Navbar = _interopRequireDefault(require("./Navbar"));
var _SidePanel = _interopRequireDefault(require("./SidePanel"));
var _context = require("./services/context");
var _context2 = require("../../services/log/context");
var _jsxRuntime = require("react/jsx-runtime");
var _div;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ConnectedSidePanel = _ref => {
  let {
    hideSidePanel,
    showSidePanel,
    modalId,
    brandLanguage,
    onOpenHelp,
    subscriptionModalContent,
    debugModalContent,
    menuButtonRef
  } = _ref;
  const {
    isSideNavShown
  } = (0, _context.useNavConfig)();
  if (!isSideNavShown) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SidePanel.default, {
    isOpen: showSidePanel,
    modalId: modalId,
    brandLanguage: brandLanguage,
    onOpenHelp: onOpenHelp,
    hidePanel: hideSidePanel,
    subscriptionModalContent: subscriptionModalContent,
    debugModalContent: debugModalContent,
    menuButtonRef: menuButtonRef
  });
};
const TopNav = _ref2 => {
  let {
    isSidePanelOpen = false,
    modalId,
    subscriptionModalContent,
    debugModalContent,
    brandLanguage,
    onOpenHelp,
    onSaveRegionalSettings,
    onLogoClick,
    urlLogo,
    hide = [],
    active,
    bottomStyle = "shadow",
    transparentBgAtTop = false
  } = _ref2;
  const intl = (0, _reactIntl.useIntl)();
  const {
    log
  } = (0, _context2.useLog)();
  const [showSidePanel, setSidePanel] = React.useState(isSidePanelOpen);
  const menuButtonRef = React.useRef(null);
  const hideSidePanel = React.useCallback(() => {
    log(events.CLOSE_SIDE_NAV, {});
    setSidePanel(false);
  }, [log]);
  const displaySidePanel = React.useCallback(() => {
    log(events.OPEN_SIDE_NAV, {});
    setSidePanel(true);
  }, [log]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_context.NavConfigProvider, {
    value: {
      hide,
      onSaveRegionalSettings
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_NavigationBar.default, {
      dataTest: "TopNav",
      bottomStyle: bottomStyle,
      openTitle: intl.formatMessage({
        id: "orbit.navigationbar_open_menu"
      }),
      transparentBgAtTop: transparentBgAtTop,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Navbar.default, {
        modalId: modalId,
        brandLanguage: brandLanguage,
        togglePanel: displaySidePanel,
        onOpenHelp: onOpenHelp,
        onLogoClick: onLogoClick,
        urlLogo: urlLogo,
        active: active,
        menuButtonRef: menuButtonRef
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ConnectedSidePanel, {
      showSidePanel: showSidePanel,
      hideSidePanel: hideSidePanel,
      modalId: modalId,
      brandLanguage: brandLanguage,
      onOpenHelp: onOpenHelp,
      debugModalContent: debugModalContent,
      subscriptionModalContent: subscriptionModalContent,
      menuButtonRef: menuButtonRef
    }), modalId == null && (_div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "absolute z-modal",
      id: "navbar-modals"
    })))]
  });
};
var _default = exports.default = TopNav;